import { PROVIDE_CLIENT_INTAKE_RESPONSES_STATE } from '@db-access/clientIntakeResponses';
import { PROVIDE_FB_CLIENT_INTAKE_FORMS_STATE } from '@db-access/clientIntakeForms';
import { PROVIDE_CLIENT_INTAKE_FORM_CONTEXT_STATE } from '@db-access/clientIntakeFormContext';
import { PROVIDE_CLIENT_INTAKE_FORM_ITEMS_STATE } from '@db-access/clientIntakeFormItems';
import { provideStates } from '@ngxs/store';
import { PortalEngineState } from './state/portal-engine.state';
import { PortalEngineService } from './services/portal-engine.service';

export const PROVIDE_PORTAL_ENGINE_STATE = [
	...PROVIDE_CLIENT_INTAKE_RESPONSES_STATE,
	...PROVIDE_FB_CLIENT_INTAKE_FORMS_STATE,
	...PROVIDE_CLIENT_INTAKE_FORM_CONTEXT_STATE,
	...PROVIDE_CLIENT_INTAKE_FORM_ITEMS_STATE,
	provideStates([PortalEngineState]),
	PortalEngineService,
];
